import React, {FC, useCallback} from 'react';
import  './index.scss';

interface StatusProps {
    value: string;
    statusType: string;
    className?: string;
}


export const CreditStatus: FC<StatusProps> = ({value, statusType, className}) => {

    const renderIcon = () => {
        switch (statusType) {
            case 'Ödənilibdir':
                return  'creditStatus__type--paid';
            case 'Погашено':
                return  'creditStatus__type--paid';
            case 'Closed':
                return  'creditStatus__type--paid';
            case 'Gecikmədədir':
                return  'creditStatus__type--latePaid';
            case 'На просрочке':
                return  'creditStatus__type--latePaid';
            case 'On delay':
                return  'creditStatus__type--latePaid';
            case 'Gecikmədə deyil':
                return  'creditStatus__type--notLatePaid';
            case "Не просрочен":
                return  'creditStatus__type--notLatePaid';
            case "No delay":
                return  'creditStatus__type--notLatePaid';
            default:
                return null;
        }
    };

    return (
        <div className={`creditStatus ${className}`}>
            <span className={`creditStatus__type ${renderIcon()}`}/>
            <span className={'creditStatus__text'}>{value}</span>
        </div>
    );
};
